import { useTranslation } from 'react-i18next'
import styles from './PaginationActions.module.scss'
import { Button, Flex, Icon, Typography } from '@percent/lemonade'

type PaginationActionsProps = {
  count: number
  nextPage: VoidFunction | null
  previousPage: VoidFunction | null
  refresh: VoidFunction | null
}

export function PaginationActions({ count, nextPage, previousPage, refresh }: PaginationActionsProps) {
  const { t } = useTranslation()

  const handleRefreshButtonClick = () => refresh?.()
  const handleBackButtonClick = () => previousPage?.()
  const handleNextButtonClick = () => nextPage?.()

  return (
    <div className={styles.container}>
      <Typography>{t('typography.results', { count })}</Typography>
      <Flex align="center" gap={4} className={styles.buttonsWrapper}>
        {refresh ? (
          <Button
            onClick={handleRefreshButtonClick}
            variant="tertiary"
            data-testid="refresh-button"
            aria-label="refresh"
          >
            <Icon name="recurring" size={6} />
          </Button>
        ) : null}

        <Button
          onClick={handleBackButtonClick}
          disabled={!previousPage}
          variant="tertiary"
          aria-label="previous page"
          data-testid="back-button"
        >
          <Icon name="chevron-left" size={6} />
        </Button>
        <Button
          onClick={handleNextButtonClick}
          disabled={!nextPage}
          variant="tertiary"
          aria-label="next page"
          data-testid="next-button"
        >
          <Icon name="chevron-right" size={6} />
        </Button>
      </Flex>
    </div>
  )
}
